// extracted by css-extract-rspack-plugin
export default {"cls1":"Dropdown-cls1_GZG","cls2":"Dropdown-cls2_GqJ Dropdown-cls1_GZG"};